import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { CodeIcon, SmartphoneIcon, GlobeIcon, CpuIcon, LayersIcon } from 'lucide-react';
export function TrustBar() {
  const revealRef = useScrollReveal();
  const logos = [{
    icon: <GlobeIcon className="w-5 h-5" data-id="element-564" data-mp="y6mmyu0rvb9x" />,
    label: 'Google'
  }, {
    icon: <CpuIcon className="w-5 h-5" data-id="element-565" data-mp="138262gje37po" />,
    label: 'Gemini'
  }, {
    icon: <SmartphoneIcon className="w-5 h-5" data-id="element-566" data-mp="1qyps05q53xv8" />,
    label: 'PWA'
  }, {
    icon: <CodeIcon className="w-5 h-5" data-id="element-567" data-mp="1uz9pjaeml3hw" />,
    label: 'React'
  }, {
    icon: <LayersIcon className="w-5 h-5" data-id="element-568" data-mp="1gzgz7g70gpag" />,
    label: 'TypeScript'
  }];
  return <section ref={revealRef} className="py-14 border-y border-gray-100/80 bg-gradient-to-r from-gray-50/50 via-white to-gray-50/50 overflow-hidden" data-id="element-569" data-mp="1lybhmh12gbu1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-570" data-mp="5iqrttquprf9">
        <p className="reveal text-center text-[10px] font-semibold tracking-[0.25em] text-apple-gray uppercase mb-10" data-id="element-571" data-mp="ajep2x5ob4hx">
          Technológie ktorým dôverujeme
        </p>
        <div className="reveal reveal-delay-1 flex flex-wrap justify-center items-center gap-12 md:gap-20" data-id="element-572" data-mp="16hldz16t1nee">
          {logos.map((logo, i) => <div key={i} className="flex items-center gap-2.5 text-gray-400 hover:text-apple-black transition-all duration-500 group cursor-default" data-id="element-573" data-mp="1khw9wimz1s6f" data-mpi={i}>
              <span className="group-hover:scale-110 transition-transform duration-300" data-id="element-574" data-mp="1tggius2qcnhg">
                {logo.icon}
              </span>
              <span className="font-bold text-lg tracking-tight" data-id="element-575" data-mp="1ped5tz0exau2">
                {logo.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}